import { useContext } from "react";
import { ThemeContext } from "../../utils/ThemeContext";
import './style.css';

function Footer() {
    const theme = useContext(ThemeContext);
    console.log(theme);
    return (
        <div id={"footer"}><a href="https://instagram.com/creasite.be">@creasite.be</a></div>
    )
}

export default Footer;